/*
  BEZET — керування двопанельною бургер-навігацією.

  Відкриттям/закриттям самого drawer далі керує DrawerNavSection із base.js —
  тут лише те, що відбувається всередині: який рейл активний, який третій
  рівень відкрито, і скидання стану після закриття.

  Делегування на контейнер, а не на кожен вузол: розмітка приходить із
  секції й може перерендеритись у кастомайзері.
*/

(function () {
  'use strict';

  const ROOT = '.bz-nav';

  function panes(root) {
    return root.querySelectorAll('.bz-nav__pane');
  }

  function closeSubpanes(root) {
    root.querySelectorAll('.bz-nav__subpane').forEach((el) => {
      el.hidden = true;
    });
  }

  function selectPane(root, key) {
    closeSubpanes(root);

    panes(root).forEach((pane) => {
      pane.hidden = pane.dataset.pane !== key;
    });

    root.querySelectorAll('.bz-nav__rail-item').forEach((item) => {
      item.setAttribute('aria-selected', item.dataset.pane === key ? 'true' : 'false');
    });

    // Прокрутка панелі скидається — інакше нова категорія відкривається
    // десь із середини списку попередньої
    const active = root.querySelector('.bz-nav__pane:not([hidden])');
    if (active) active.scrollTop = 0;
  }

  function openSubpane(root, key) {
    const target = root.querySelector('.bz-nav__subpane[data-sub="' + CSS.escape(key) + '"]');
    if (!target) return;

    closeSubpanes(root);
    target.hidden = false;
    target.scrollTop = 0;

    const back = target.querySelector('.bz-nav__back');
    if (back) back.focus();
  }

  function reset(root) {
    const first = root.querySelector('.bz-nav__rail-item[data-pane]');
    if (first) selectPane(root, first.dataset.pane);
  }

  function init(root) {
    if (root.dataset.bzNavReady === 'true') return;
    root.dataset.bzNavReady = 'true';

    root.addEventListener('click', (event) => {
      const railItem = event.target.closest('.bz-nav__rail-item[data-pane]');
      if (railItem && root.contains(railItem)) {
        event.preventDefault();
        selectPane(root, railItem.dataset.pane);
        return;
      }

      const parentRow = event.target.closest('.bz-nav__row--parent[data-sub]');
      if (parentRow && root.contains(parentRow)) {
        event.preventDefault();
        openSubpane(root, parentRow.dataset.sub);
        return;
      }

      const back = event.target.closest('.bz-nav__back');
      if (back && root.contains(back)) {
        event.preventDefault();
        closeSubpanes(root);
        const opener = root.querySelector(
          '.bz-nav__row--parent[data-sub="' + CSS.escape(back.dataset.back || '') + '"]'
        );
        if (opener) opener.focus();
      }
    });

    // Стрілками ходимо по рейлу — він поводиться як список вкладок
    root.addEventListener('keydown', (event) => {
      const railItem = event.target.closest('.bz-nav__rail-item[data-pane]');
      if (!railItem) return;
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      const items = Array.from(root.querySelectorAll('.bz-nav__rail-item[data-pane]'));
      const step = event.key === 'ArrowDown' ? 1 : -1;
      const next = items[(items.indexOf(railItem) + step + items.length) % items.length];

      event.preventDefault();
      next.focus();
      selectPane(root, next.dataset.pane);
    });

    reset(root);

    // Закриття drawer знімає body.menu-open — ловимо це, щоб наступне
    // відкриття починалося з першої категорії, а не там, де пішов клієнт
    let wasOpen = document.body.classList.contains('menu-open');
    new MutationObserver(() => {
      const isOpen = document.body.classList.contains('menu-open');
      if (wasOpen && !isOpen) reset(root);
      wasOpen = isOpen;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Кастомайзер перерендерює секцію шапки цілком
  document.addEventListener('shopify:section:load', boot);
})();
